export default __webpack_public_path__ + "static/media/merguez.99c521f1.jpg";